import moment from 'moment';

import {
    CLEAR_DASHBOARD_DATA,
    CLEAR_DASHBOARD_CLIENT_DATA,
    CLEAR_DASHBOARD_SITE_DATA,
    CREATE_CUSTOMER_SUPPORT_REPORT,
    FETCH_CLIENT_ENERGY_DATA,
    FETCH_CLIENT_EQUIPMENT_DATA,
    FETCH_CLIENTS_DATA,
    FETCH_CLIENT_SITES_DATA,
    FETCH_CLIENT_SYSTEMS_DATA,
    FETCH_CONFIG_ENTITIES,
    FETCH_COMPANY_ENERGY_DATA,
    FETCH_COMPANY_KPI_DATA,
    FETCH_ENERGY_INTEGRATIONS,
    FETCH_ENERGY_KPI_DATA,
    FETCH_EQUIPMENT_DATA,
    FETCH_EQUIPMENT_KPI_DATA,
    FETCH_HEALTHSCORE_RAW_DATA,
    FETCH_RULE_SCORE_KPIS,
    FETCH_SENSOR_CALCULATIONS,
    SET_CLONED_FORMULA,
    SENSOR_SAVE_EVENT,
    FETCH_FORMULA_LIST,
    FETCH_COMPANY_FORMULA_LIST,
    FETCH_SENSOR_TEMPLATE,
    FETCH_SITE_EQUIPMENT_DATA,
    FETCH_SITES_DATA,
    FETCH_SITE_KPI_DATA,
    FETCH_SITE_EQUIPMENT_KPI_DATA,
    FETCH_SITE_SYSTEM_KPI_DATA,
    FETCH_SITE_SYSTEMS_DATA,
    FETCH_SYSTEM_EQUIPMENT_DATA,
    FETCH_SYSTEM_KPI_DATA,
    FETCH_SYSTEMS_DATA,
    FETCH_USER_LIST,
    FETCH_USER_ENTITIES,
    SET_CLIENT_FILTERS,
    SET_CLIENT_TAB_INDEX,
    SET_COMPANY_TAB_INDEX,
    SET_DASHBOARD_TIMEFRAME_END,
    SET_DASHBOARD_TIMEFRAME_START,
    SET_DASHBOARD_TIME_PERIOD,
    SET_DASHBOARD_END_TIMESTAMP,
    SET_DASHBOARD_ISCURRENT_TIMESTAMP,
    SET_DASHBOARD_CURRENT_TIMESTAMP,
    SET_DASHBOARD_START_TIMESTAMP,
    SET_DESIRED_INTERVAL,
    SET_EQUIPMENT_FILTERS,
    SET_EQUIPMENT_TAB_INDEX,
    SET_FORMULA_DETAILS,
    SET_FORMULA_GRID_COLUMNS,
    SET_RULE_SCORING_CONFIGURATION,
    SET_SELECTED_RULE,
    SET_SELECTED_RULE_FROM_FAULTS_PAGE,
    SET_SELECTED_RULE_SENSORS,
    SET_SELECTED_SENSOR,
    SET_SELECTED_SENSORS,
    SET_SELECTED_WEATHER_SENSORS,
    SET_SENSOR_CONFIGURATION,
    SET_SITE_FAULT_SUMMARY,
    SET_SITE_FILTERS,
    SET_SITE_TAB_INDEX,
    SET_SYSTEM_FILTERS,
    SET_SYSTEM_TAB_INDEX,
    SET_SHOW_EXPORT_MODAL,
    SET_TEMPLATE_DETAILS,
    FETCH_ANNOUNCEMENTS,
    FETCH_REPORT_LIST,
    FETCH_REPORT_LISTS,
    CREATE_INSPECTION_REPORT,
    FETCH_ANNOUNCEMENT_MSG,
    SET_HEALTH_MONITOR_FILTERS,
    SET_EMAILS,
    SET_WORKBOOK_MODE
} from '../actions/actionTypes';

const initialState = {
    clientEquipment:             [],
    clientEquipmentMeta:         {},
    clientFilters:               { type: [], priority: { high: false, medium: false, low: false } },
    clients:                     [],
    clientsMeta:                 {},
    clientSites:                 [],
    clientSitesMeta:             {},
    clientSystems:               [],
    clientSystemsMeta:           {},
    clientTabIndex:              0,
    configEntities:              [],
    companyKpis:                 [],
    companyTabIndex:             0,
    dashboardTimeframeEnd:       moment().local(),
    dashboardTimeframeStart:     moment().local(),
    dashboardTimePeriod:         'Current',
    dashboardEndTimeStamp:       moment().local(),
    dashboardIsCurrentTimeStamp: true,
    dashboardCurrentTimeStamp:   moment().local(),
    dashboardStartTimeStamp:     moment().set('minute', Math.floor(moment().minute() / 15) * 15).subtract(1, 'd').local(),
    desiredInterval:             15,
    emails:                      [],
    energyKpis:                  {},
    energyClientSites:           [],
    energyClientSitesMeta:       {},
    energyIntegrations:          [],
    energyIntegrationsMeta:      {},
    energySites:                 [],
    energySitesMeta:             {},
    equipmentFilters:            { type: [], priority: { high: false, medium: false, low: false } },
    equipmentKpis:               {},
    equipmentTabIndex:           0,
    equipment:                   [],
    equipmentMeta:               {},
    formulaGridColumns:          [],
    healthscoreRawData:          [],
    healthscoreRawDataMeta:      {},
    isShowExportModal:           false,
    ruleScoreKpis:               [],
    ruleScoringConfig:           { current: {}, previous: [] },
    selectedRule:                {},
    selectedRuleFromFaultsPage:  {},
    selectedRuleSensors:         [],
    selectedSensor:              {},
    selectedSensors:             [],
    selectedWeatherSensors:      [],
    sensorCalculations:          [],
    sensorConfiguration:         {},
    serviceRequests:             [],
    serviceRequestsMeta:         {},
    siteEquipment:               [],
    siteEquipmentMeta:           {},
    siteKpis:                    {},
    siteEquipmentKpis:           {},
    siteSystemKpis:              {},
    siteFaultSummary:            [],
    siteFaultSummaryMeta:        {},
    siteFilters:                 { type: [], priority: { high: false, medium: false, low: false } },
    sites:                       [],
    sitesMeta:                   {},
    siteSystems:                 [],
    siteSystemsMeta:             {},
    siteTabIndex:                0,
    systemEquipment:             [],
    systemEquipmentMeta:         {},
    systemFilters:               { type: [], priority: { high: false, medium: false, low: false } },
    healthMonitorFilters:        { type: [], priority: { high: false, medium: false, low: false }, status: ['Fault'] },
    systemKpis:                  {},
    systems:                     [],
    systemsMeta:                 {},
    systemTabIndex:              0,
    users:                       [],
    userApplications:            [],
    userEntities:                [],
    workbookModeEnabled:         false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR_DASHBOARD_DATA:
            return {
                ...state,
                clientEquipment:     [],
                clientEquipmentMeta: {},
                clients:             [],
                clientsMeta:         {},
                clientSites:         [],
                clientSitesMeta:     {},
                clientSystems:       [],
                clientSystemsMeta:   {},
                equipment:           [],
                equipmentMeta:       {},
                siteEquipment:       [],
                siteEquipmentMeta:   {},
                sites:               [],
                sitesMeta:           {},
                siteSystems:         [],
                siteSystemsMeta:     {},
                systems:             [],
                systemsMeta:         {}
            };
        case CLEAR_DASHBOARD_CLIENT_DATA:
            return {
                ...state,
                clientEquipment:     [],
                clientEquipmentMeta: {},
                clientSites:         [],
                clientSitesMeta:     {},
                clientSystems:       [],
                clientSystemsMeta:   {},
                siteEquipment:       [],
                siteEquipmentMeta:   {},
                siteSystems:         [],
                siteSystemsMeta:     {}
            };
        case CLEAR_DASHBOARD_SITE_DATA:
            return {
                ...state,
                siteEquipment:     [],
                siteEquipmentMeta: {},
                siteSystems:       [],
                siteSystemsMeta:   {}
            };
        case FETCH_CLIENT_ENERGY_DATA:
            return {
                ...state,
                energyClientSites:     [...action.payload.energyClientSites],
                energyClientSitesMeta: { ...action.payload.meta }
            };
        case FETCH_CLIENT_EQUIPMENT_DATA:
            return {
                ...state,
                clientEquipment:     [...action.payload.clientEquipment],
                clientEquipmentMeta: {...action.payload.meta}
            };
        case FETCH_CLIENTS_DATA:
            return {
                ...state,
                clients:     [...action.payload.clients],
                clientsMeta: {...action.payload.meta}
            };
        case FETCH_CLIENT_SITES_DATA:
            return {
                ...state,
                clientSites:     [...action.payload.clientSites],
                clientSitesMeta: {...action.payload.meta}
            };
        case FETCH_CLIENT_SYSTEMS_DATA:
            return {
                ...state,
                clientSystems:     [...action.payload.clientSystems],
                clientSystemsMeta: {...action.payload.meta}
            };
        case FETCH_COMPANY_ENERGY_DATA:
            return {
                ...state,
                energySites:     [...action.payload.energySites],
                energySitesMeta: {...action.payload.meta}
            };
        case FETCH_COMPANY_KPI_DATA:
            return {
                ...state,
                companyKpis: [...action.payload]
            };
        case FETCH_ENERGY_INTEGRATIONS:
            return {
                ...state,
                energyIntegrations:     [...action.payload.energyIntegrations],
                energyIntegrationsMeta: { ...action.payload.meta }
            };
        case FETCH_ENERGY_KPI_DATA:
            return {
                ...state,
                energyKpis: { ...action.payload }
            };
        case FETCH_EQUIPMENT_DATA:
            return {
                ...state,
                equipment:     [...action.payload.equipment],
                equipmentMeta: {...action.payload.meta}
            };
        case FETCH_EQUIPMENT_KPI_DATA:
            return {
                ...state,
                equipmentKpis: { ...action.payload }
            };
        case FETCH_RULE_SCORE_KPIS:
            return {
                ...state,
                ruleScoreKpis: [...action.payload]
            };
        case FETCH_SENSOR_CALCULATIONS:
            return {
                ...state,
                sensorCalculations: [...action.payload]
            };
        case SET_CLONED_FORMULA:
            return {
                ...state,
                clonedFormula: action.payload
            };
        case SENSOR_SAVE_EVENT:
            return {
                ...state,
                createSensorEvent: action.payload
            };
            
        case FETCH_FORMULA_LIST:
            return {
                ...state,
                formulaList: [...action.payload]
            };
        case FETCH_COMPANY_FORMULA_LIST:
            return {
                ...state,
                companyFormulaList: [...action.payload]
            };
        case SET_FORMULA_DETAILS:
            return {
                ...state,
                activeFormula: {...action.payload}
            };
        case SET_FORMULA_GRID_COLUMNS:
            return {
                ...state,
                formulaGridColumns: [...action.payload]
            };
        case SET_TEMPLATE_DETAILS:
            return {
                ...state,
                activeTemplate: {...action.payload}
            };
        case FETCH_SENSOR_TEMPLATE:
            return {
                ...state,
                sensorTemplate: [...action.payload]
            };
            
        case FETCH_SITE_EQUIPMENT_DATA:
            return {
                ...state,
                siteEquipment:     [...action.payload.siteEquipment],
                siteEquipmentMeta: {...action.payload.meta}
            };
        case FETCH_SITES_DATA:
            return {
                ...state,
                sites:     [...action.payload.sites],
                sitesMeta: {...action.payload.meta}
            };
        case FETCH_SITE_KPI_DATA:
            return {
                ...state,
                siteKpis: { ...action.payload }
            };
        case FETCH_SITE_EQUIPMENT_KPI_DATA:
            return {
                ...state,
                siteEquipmentKpis: { ...action.payload }
            };
        case FETCH_SITE_SYSTEM_KPI_DATA:
            return {
                ...state,
                siteSystemKpis: { ...action.payload }
            };
        case FETCH_SITE_SYSTEMS_DATA:
            return {
                ...state,
                siteSystems:     [...action.payload.siteSystems],
                siteSystemsMeta: {...action.payload.meta}
            };
        case FETCH_SYSTEM_EQUIPMENT_DATA:
            return {
                ...state,
                systemEquipment:     [...action.payload.systemEquipment],
                systemEquipmentMeta: { ...action.payload.meta }
            };
        case FETCH_SYSTEM_KPI_DATA:
            return {
                ...state,
                systemKpis: { ...action.payload }
            };
        case FETCH_SYSTEMS_DATA:
            return {
                ...state,
                systems:     [...action.payload.systems],
                systemsMeta: {...action.payload.meta}
            };
        case FETCH_CONFIG_ENTITIES:
            return {
                ...state,
                configEntities: [...action.payload]
            };
        case SET_CLIENT_FILTERS:
            return {
                ...state,
                clientFilters: { ...action.payload }
            };
        case SET_CLIENT_TAB_INDEX:
            return {
                ...state,
                clientTabIndex: action.payload
            };
        case SET_COMPANY_TAB_INDEX:
            return {
                ...state,
                companyTabIndex: action.payload
            };
        case SET_EQUIPMENT_FILTERS:
            return {
                ...state,
                equipmentFilters: { ...action.payload }
            };
        case SET_EQUIPMENT_TAB_INDEX:
            return {
                ...state,
                equipmentTabIndex: action.payload
            };
        case SET_RULE_SCORING_CONFIGURATION:
            return {
                ...state,
                ruleScoringConfig: { ...action.payload }
            };
        case SET_SELECTED_RULE:
            return {
                ...state,
                selectedRule: { ...action.payload }
            };
        case SET_SELECTED_RULE_FROM_FAULTS_PAGE:
            return {
                ...state,
                selectedRuleFromFaultsPage: { ...action.payload }
            };
        case SET_SELECTED_RULE_SENSORS:
            return {
                ...state,
                selectedRuleSensors: [...action.payload]
            };
        case SET_SELECTED_SENSOR:
            return {
                ...state,
                selectedSensor: { ...action.payload }
            };
        case SET_SELECTED_SENSORS:
            return {
                ...state,
                selectedSensors: [...action.payload]
            };
        case SET_SELECTED_WEATHER_SENSORS:
            return {
                ...state,
                selectedWeatherSensors: [...action.payload]
            };
        case SET_SENSOR_CONFIGURATION:
            return {
                ...state,
                sensorConfiguration: { ...action.payload }
            };
        case SET_SITE_FILTERS:
            return {
                ...state,
                siteFilters: { ...action.payload }
            };
        case SET_SITE_TAB_INDEX:
            return {
                ...state,
                siteTabIndex: action.payload
            };
        case SET_SYSTEM_FILTERS:
            return {
                ...state,
                systemFilters: { ...action.payload }
            };
        case SET_HEALTH_MONITOR_FILTERS:
            return {
                ...state,
                healthMonitorFilters: { ...action.payload }
            };
        case SET_SYSTEM_TAB_INDEX:
            return {
                ...state,
                systemTabIndex: action.payload
            };
        case SET_DASHBOARD_TIMEFRAME_END:
            return {
                ...state,
                dashboardTimeframeEnd: action.payload
            };
        case SET_DASHBOARD_TIMEFRAME_START:
            return {
                ...state,
                dashboardTimeframeStart: action.payload
            };
        case SET_DASHBOARD_TIME_PERIOD:
            return {
                ...state,
                dashboardTimePeriod: action.payload
            };
        case SET_DASHBOARD_START_TIMESTAMP:
            return {
                ...state,
                dashboardStartTimeStamp: action.payload
            };
        case SET_DASHBOARD_END_TIMESTAMP:
            return {
                ...state,
                dashboardEndTimeStamp: action.payload
            };
        case SET_DESIRED_INTERVAL:
            return {
                ...state,
                desiredInterval: action.payload
            };
        case SET_SHOW_EXPORT_MODAL:
            return {
                ...state,
                isShowExportModal: action.payload
            };
        case FETCH_USER_LIST:
            return {
                ...state,
                users:     [...action.payload.users],
                usersMeta: {...action.payload.meta}
            };
        case FETCH_ANNOUNCEMENTS:
            return {
                ...state,
                announcements: action.payload
            };
        case FETCH_ANNOUNCEMENT_MSG:
            return {
                ...state,
                announcement: action.payload
            };
        case FETCH_USER_ENTITIES:
            return {
                ...state,
                userEntities: action.payload
            };
        case FETCH_REPORT_LIST:
            return {
                ...state,
                inspectionReports: [...action.results]
            };
        case FETCH_REPORT_LISTS:
        {
            let inspectionReports = state.inspectionReports;

            if (inspectionReports) {
                inspectionReports.forEach(report => {
                    if (report.processId === action.payload.processId) {
                        report.status = action.payload.status;
                        report.reportData = {...action.payload.result.reportData};
                    }
                });
            }
            else {
                inspectionReports = [];
            }

            return {
                ...state,
                inspectionReports: [...inspectionReports]
            };
        }
        case CREATE_CUSTOMER_SUPPORT_REPORT:
            return {
                ...state,
                processId: action.payload
            };
        case CREATE_INSPECTION_REPORT:
            return {
                ...state,
                processId: action.payload
            };
        case SET_DASHBOARD_ISCURRENT_TIMESTAMP:
            return {
                ...state,
                dashboardIsCurrentTimeStamp: action.payload
            };
        case SET_DASHBOARD_CURRENT_TIMESTAMP:
            return {
                ...state,
                dashboardCurrentTimeStamp: action.payload
            };
        case SET_EMAILS:
            return {
                ...state,
                emails: action.payload
            };
        case SET_WORKBOOK_MODE:
            return {
                ...state,
                workbookModeEnabled: action.payload
            };
        case SET_SITE_FAULT_SUMMARY:
            return {
                ...state,
                siteFaultSummary:     [...action.payload.data],
                siteFaultSummaryMeta: {...action.payload.meta}
            };
        case FETCH_HEALTHSCORE_RAW_DATA:
            return {
                ...state,
                healthscoreRawData:     [...action.payload.data],
                healthscoreRawDataMeta: {...action.payload.meta}
            };
        default:
            return state;
    }
};
